// store/modules/analyticsVisitors.js

import http from '@root/utils/axios/admin';

let state = {

    Overview: {},

    VisitsPerHour: [],

    VisitsPerDay: [],

    Sources: [],

    Campaigns: [],

    Devices: [],

    Platforms: [],

    Browsers: [],

    TopPages: [],

    Realtime: {},

    Countries: [],

    Cities: [],

    Bots: {},

    Funnel: [],

}

let actions = {

    fetchVisitorsOverview({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/overview', {
                params: filter
            }).then((response) => {

                commit('setVisitorsOverview', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchVisitsPerHour({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/visits-per-hour', {
                params: filter
            }).then((response) => {

                commit('setVisitsPerHour', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchVisitsPerDay({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/visits-per-day', {
                params: filter
            }).then((response) => {

                commit('setVisitsPerDay', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchSources({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/sources', {
                params: filter
            }).then((response) => {

                commit('setSources', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchCampaigns({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/campaigns', {
                params: filter
            }).then((response) => {

                commit('setCampaigns', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchDevices({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/devices', {
                params: filter
            }).then((response) => {

                commit('setDevices', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchPlatforms({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/platforms', {
                params: filter
            }).then((response) => {

                commit('setPlatforms', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchBrowsers({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/browsers', {
                params: filter
            }).then((response) => {

                commit('setBrowsers', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchTopPages({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/top-pages', {
                params: filter
            }).then((response) => {

                commit('setTopPages', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchRealtime({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/realtime', {
                params: filter
            }).then((response) => {

                commit('setRealtime', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchCountries({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/countries', {
                params: filter
            }).then((response) => {

                commit('setCountries', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchCities({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/cities', {
                params: filter
            }).then((response) => {

                commit('setCities', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchBots({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/bots', {
                params: filter
            }).then((response) => {

                commit('setBots', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

    fetchFunnel({ commit }, filter = {}) {

        return new Promise((resolve, reject) => {

            http.get('/user/analytics/visitors/funnel', {
                params: filter
            }).then((response) => {

                commit('setFunnel', response.data);

                resolve(response);

            }).catch((errors) => {

                reject(errors);

            })

        })

    },

}

let mutations = {

    setVisitorsOverview(state, data) {

        state.Overview = data;

    },

    setVisitsPerHour(state, data) {

        state.VisitsPerHour = data;

    },

    setVisitsPerDay(state, data) {

        state.VisitsPerDay = data;

    },

    setSources(state, data) {

        state.Sources = data;

    },

    setCampaigns(state, data) {

        state.Campaigns = data;

    },

    setDevices(state, data) {

        state.Devices = data;

    },

    setPlatforms(state, data) {

        state.Platforms = data;

    },

    setBrowsers(state, data) {

        state.Browsers = data;

    },

    setTopPages(state, data) {

        state.TopPages = data;

    },

    setRealtime(state, data) {

        state.Realtime = data;

    },

    setCountries(state, data) {

        state.Countries = data;

    },

    setCities(state, data) {

        state.Cities = data;

    },

    setBots(state, data) {

        state.Bots = data;

    },

    setFunnel(state, data) {

        state.Funnel = data;

    },

}

export default {

    state,

    actions,

    mutations

}